var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header main-header w-full text-[16px] justify-center font-[500px] flex flex-col"},[_c('div',{staticClass:"header__top border-b"},[_c('div',{staticClass:"container items-center flex justify-between"},[_c('NavigationMenu'),_c('NavigationMenuR')],1)]),_c('HeaderSecond'),_c('BottomHeader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }